export function validateName(name) {
    if (!name) {
        throw new Error(`Name is missing.`);
    }
    if (typeof name !== 'string') {
        throw new Error(`Name is not a string.`);
    }
    if (!name.match(/^[a-zA-Z0-9-\\.]+$/)) {
        throw new Error(`Name contains invalid characters: ${name}.`);
    }
    const labels = name.split('.');
    if (labels.length < 2) {
        throw new Error(`Name must contain at least two labels: ${name}.`);
    }
    for (const label of labels) {
        validateDomainLabel(label);
    }
}
export function validateDomainLabel(label) {
    if (label.length > 63) {
        throw new Error(`Name label is too long: ${label}.`);
    }
    if (label.startsWith('-') || label.endsWith('-')) {
        throw new Error(`Name label cannot start or end with a hyphen: ${label}.`);
    }
}
export function getNameTLD(name) {
    const labels = name.split('.');
    return labels[labels.length - 1];
}
//# sourceMappingURL=utils.js.map